// Styles
import { makeStyles, tokens } from "@fluentui/react-components";
import { textClip } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * Styles for ShareMenuButton
 */ export const useShareMenuButtonStyles = makeStyles({
    shareButton: {
        minWidth: "auto",
        borderRadius: tokens.borderRadiusXLarge
    },
    menuPopover: {
        width: "240px",
        borderRadius: tokens.borderRadiusXLarge
    },
    menuItem: {
        width: "100%",
        color: tokens.colorNeutralForeground1,
        ":hover": {
            color: tokens.colorNeutralForeground1Hover
        }
    },
    staticItemContent: {
        ...textClip("ellipsis")
    },
    staticText: {
        ...textClip("ellipsis")
    },
    menuBorder: {
        margin: "3px -4px"
    }
});
